import * as React from "react"

const SvgCenterAlign = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 21.286a.97.97 0 0 1-.712-.288.97.97 0 0 1-.288-.712q0-.425.288-.713A.97.97 0 0 1 4 19.286h16a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288zm4-4a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287h8a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288zm-4-4a.97.97 0 0 1-.712-.288.97.97 0 0 1-.288-.712q0-.426.288-.713A.97.97 0 0 1 4 11.286h16a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288zm4-4a.97.97 0 0 1-.713-.288A.97.97 0 0 1 7 8.286a.97.97 0 0 1 .287-.713A.97.97 0 0 1 8 7.286h8a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288zm-4-4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 4.286q0-.425.288-.713A.97.97 0 0 1 4 3.286h16a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288z" />
  </svg>
)
export default SvgCenterAlign
